// removed by extract-text-webpack-plugin
module.exports = {"label-name":"src-lib-components-__PaymentProfileLabel__label-name--t-sTf","label-name-link":"src-lib-components-__PaymentProfileLabel__label-name-link--2emEM src-lib-components-__PaymentProfileLabel__label-name--t-sTf","label-description":"src-lib-components-__PaymentProfileLabel__label-description--19jwp","installment":"src-lib-components-__PaymentProfileLabel__installment--2dVEj","installment-name":"src-lib-components-__PaymentProfileLabel__installment-name--2eNvj","installment-description":"src-lib-components-__PaymentProfileLabel__installment-description--1ENXM"};


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/PaymentProfileLabel.less
// module id = 1858
// module chunks = 0